import React from 'react';
import {
  BiLockOpenAlt,
  BiLockAlt,
  BiTrashAlt,
  BiCopy,
  BiEdit,
  BiDownload,
  BiUpload,
  BiFilterAlt,
  BiPlus,
  BiCheck,
  BiRevision,
  BiArrowBack,
  BiSearch,
  BiPrinter,
} from 'react-icons/bi';
import { BsLock, BsUnlock } from 'react-icons/bs';

import { MdApproval } from 'react-icons/md';

import { Input, Tag, Select, Badge, Button, Dropdown, Menu } from 'antd';
import {
  ButtonToolbarWrapperProps,
  PageToolbarSimpleProps,
} from './page-toolbar-simple.entity';
import { ButtonToolbarWrapper } from './button-toolbar-wrapper';
import {
  EnumColorStatusData,
  EnumStatusData,
} from '../../../../domain/entities';
import { stringFormatter } from '../../../../infrastructure/helpers';
import './page-toolbar-simple.less';
import { useState } from 'react';
import { useMediaQuery, usePageProvider } from '../../../hooks';
import { AntdIconWrapper } from './icon-toolbar-wrapper';
import { AiOutlineMenu } from 'react-icons/ai';

function makeColorStatus(status) {
  if (status?.toLowerCase() === EnumStatusData.active)
    return EnumColorStatusData.active;
  else if (status?.toLowerCase() === EnumStatusData.inactive)
    return EnumColorStatusData.inactive;
  return '';
}

export function PageToolbarSimple(props: PageToolbarSimpleProps) {
  const {
    pageTitle,
    showTagStatus = true,
    rowData,
    buttonRightContent,
    showTitle = true,

    dataTypeValue = 'original',
    handleChangeDataType,
    showDataTypeSelector = true,
    disableDataTypeSelector = false,

    defaultSearchValue,
    handleSearch,
    showSearch = true,
    disableSearch = false,
    showSearchBadge = false,

    handleClickBack,
    loadingBack,
    showBack = true,
    disableBack = false,

    handleClickReload,
    loadingReload,
    showReload = true,
    disableReload = false,

    handleClickConfirmProcess,
    loadingConfirmProcess,
    showConfirmProcess = true,
    disableConfirmProcess = false,

    handleClickApproval,
    loadingApproval,
    showApproval = true,
    disableApproval = false,

    handleClickUpdate,
    loadingUpdate,
    showUpdate = true,
    disableUpdate = false,

    handleClickDuplicate,
    loadingDuplicate,
    showDuplicate = true,
    disableDuplicate = false,

    handleClickDelete,
    loadingDelete,
    showDelete = true,
    disableDelete = false,

    handleClickActivate,
    loadingActivate,
    showActivate = true,
    disableActivate = false,

    handleClickDeactivate,
    loadingDeactivate,
    showDeactivate = true,
    disableDeactivate = false,

    handleClickFilter,
    loadingFilter,
    showFilter = true,
    disableFilter = false,
    showFilterBadge = false,

    handleClickPrint,
    loadingPrint,
    showPrint = true,
    disablePrint = false,

    handleClickExport,
    loadingExport,
    showExport = true,
    disableExport = false,

    handleClickImport,
    loadingImport,
    showImport = true,
    disableImport = false,

    handleClickNewData,
    loadingNewData,
    showNewData = true,
    disableNewData = false,

    handleClickSave,
    loadingSave,
    showSave = true,
    disableSave = false,
    additionalButtonAction = [],
  } = props;
  const [showSearchInput, setShowSearchInput] = useState(false);
  const { filterDataTable } = usePageProvider();

  const isMobile = useMediaQuery({ media: 'mobile' });
  const isTablet = useMediaQuery({ media: 'tablet' });

  const ButtonLeftContent: ButtonToolbarWrapperProps[] = [
    {
      tooltipTitle: 'Back',
      separatorPlacement: 'right',
      icon: <BiArrowBack />,
      hidden: !showBack,
      loadingButton: loadingBack,
      handleClick: handleClickBack,
      disabled: disableBack,
    },
    {
      tooltipTitle: 'Reload',
      separatorPlacement: 'right',
      icon: <BiRevision />,
      hidden: !showReload,
      loadingButton: loadingReload,
      handleClick: handleClickReload,
      disabled: disableReload,
    },
  ];

  const FilterBadge = () => {
    if (showFilterBadge) {
      let hasFilter = false;
      const filterKeys = Object.keys(filterDataTable);
      const newFilterKey: string[] = [];
      let newFilter: any = {};
      const excludeKey = [
        'q',
        'search',
        'q_index',
        'page',
        'limit',
        'order_by',
        'sort_by',
      ];
      const newExcludeKey = [...excludeKey];
      filterKeys.forEach((itemKey: string) => {
        const inExclude = newExcludeKey.includes(itemKey);
        if (!inExclude) newFilterKey.push(itemKey);
      });

      newFilterKey.forEach(itemNewKey => {
        if (filterDataTable[itemNewKey])
          newFilter = {
            ...newFilter,
            [`${itemNewKey}`]: filterDataTable[itemNewKey],
          };
      });
      if (Object.values(newFilter).length === 0) hasFilter = false;
      else hasFilter = true;
      return (
        <Badge
          {...(hasFilter
            ? { dot: true, color: 'gold' }
            : { className: 'm-top-5' })}
        >
          <i
            className=" hover-primary mdi mdi-filter-outline fs-20"
            aria-disabled
          ></i>
        </Badge>
      );
    }
    return <></>;
  };

  const ButtonRightContent: ButtonToolbarWrapperProps[] = [
    ...additionalButtonAction,
    {
      tooltipTitle: 'Confirm Process',
      buttonTitle: 'Confirm Process',
      icon: <BiCheck />,
      hidden: !showConfirmProcess,
      loadingButton: loadingConfirmProcess,
      handleClick: handleClickConfirmProcess,
      disabled: disableConfirmProcess,
    },
    {
      tooltipTitle: 'Approval',
      buttonTitle: 'Approval',
      icon: <MdApproval />,
      hidden: !showApproval,
      loadingButton: loadingApproval,
      handleClick: handleClickApproval,
      disabled: disableApproval,
    },
    {
      tooltipTitle: 'Update',
      buttonTitle: 'Update',
      icon: <BiEdit />,
      hidden: !showUpdate,
      loadingButton: loadingUpdate,
      handleClick: handleClickUpdate,
      disabled: disableUpdate,
    },
    {
      tooltipTitle: 'Duplicate',
      buttonTitle: 'Duplicate',
      icon: <BiCopy />,
      hidden: !showDuplicate,
      loadingButton: loadingDuplicate,
      handleClick: handleClickDuplicate,
      disabled: disableDuplicate,
    },
    {
      tooltipTitle: 'Delete',
      buttonTitle: 'Delete',
      icon: <BiTrashAlt />,
      hidden: !showDelete,
      loadingButton: loadingDelete,
      handleClick: handleClickDelete,
      disabled: disableDelete,
    },

    {
      tooltipTitle: 'Activate',
      buttonTitle: 'Activate',
      icon: <BsUnlock />,
      hidden: !showActivate,
      loadingButton: loadingActivate,
      handleClick: handleClickActivate,
      disabled: disableActivate,
    },

    {
      tooltipTitle: 'Deactivate',
      buttonTitle: 'Deactivate',
      icon: <BsLock />,
      hidden: !showDeactivate,
      loadingButton: loadingDeactivate,
      handleClick: handleClickDeactivate,
      disabled: disableDeactivate,
    },

    {
      tooltipTitle: 'Export',
      buttonTitle: 'Export',
      icon: <BiDownload />,
      hidden: !showExport,
      loadingButton: loadingExport,
      handleClick: handleClickExport,
      disabled: disableExport,
    },

    {
      tooltipTitle: 'Import',
      buttonTitle: 'Import',
      icon: <BiUpload />,
      hidden: !showImport,
      loadingButton: loadingImport,
      handleClick: handleClickImport,
      disabled: disableImport,
    },

    {
      tooltipTitle: 'Print',
      buttonTitle: 'Print',
      icon: <BiPrinter />,
      hidden: !showPrint,
      loadingButton: loadingPrint,
      handleClick: handleClickPrint,
      disabled: disablePrint,
    },
    {
      tooltipTitle: 'Filter',
      buttonTitle: 'Filter',
      icon: <BiFilterAlt />,
      hidden: !showFilter,
      loadingButton: loadingFilter,
      handleClick: handleClickFilter,
      disabled: disableFilter,
      children: <FilterBadge />,
    },
    {
      tooltipTitle: 'New Data',
      buttonTitle: 'New Data',
      icon: <BiPlus />,
      hidden: !showNewData,
      loadingButton: loadingNewData,
      handleClick: handleClickNewData,
      disabled: disableNewData,
    },
    {
      tooltipTitle: 'Save',
      buttonTitle: 'Save',
      icon: <BiCheck />,
      hidden: !showSave,
      loadingButton: loadingSave,
      handleClick: handleClickSave,
      disabled: disableSave,
    },
  ];

  const realButtonRightContent = ButtonRightContent.filter(
    item => !item.hidden
  );

  return (
    <div id="page-toolbar-content-simple" className="no-print">
      <div className="page-toolbar-content-wrapper">
        <div className="page-toolbar-content">
          {ButtonLeftContent.map((buttonItem, index) => {
            return <ButtonToolbarWrapper key={index} {...buttonItem} />;
          })}
        </div>

        <div className="page-toolbar-content-title">
          <div className="title-page">
            {showTitle && (
              <span style={{ minWidth: '100px' }}>{pageTitle}</span>
            )}
          </div>
          <div style={{ marginLeft: '10px' }}>
            {showTagStatus && rowData && (
              <Tag color={makeColorStatus(rowData?.status)}>
                {stringFormatter.capitalizeEachWord(
                  rowData?.status
                    ?.split('_')
                    ?.join(' ')
                    ?.split('-')
                    ?.join(' ')
                )}
              </Tag>
            )}
          </div>
        </div>
        <div className="page-toolbar-content">
          <Input
            allowClear
            hidden={!showSearchInput || isMobile}
            style={{ width: '300px' }}
            placeholder="Type and press enter"
            defaultValue={defaultSearchValue}
            onChange={e => {
              if (!e.target.value && handleSearch) handleSearch(e.target.value);
            }}
            onPressEnter={e => {
              if (e.target.value && handleSearch) handleSearch(e.target.value);
            }}
          />
          <ButtonToolbarWrapper
            disabled={disableSearch}
            hidden={!showSearch}
            icon={<BiSearch />}
            showSeparator={false}
            handleClick={() => setShowSearchInput(!showSearchInput)}
          >
            {showSearchBadge && (
              <Badge
                {...(defaultSearchValue
                  ? { dot: true, color: 'gold' }
                  : { className: 'm-top-5' })}
              >
                <i
                  className=" hover-primary mdi mdi-filter-outline fs-20"
                  aria-disabled
                ></i>
              </Badge>
            )}
          </ButtonToolbarWrapper>

          {showDataTypeSelector && (
            <Select
              disabled={disableDataTypeSelector}
              value={dataTypeValue}
              onChange={handleChangeDataType}
              style={{ width: '120px', marginRight: '20px' }}
              options={[
                { label: 'Requested', value: 'requested' },
                { label: 'Original', value: 'original' },
              ]}
            />
          )}
          {buttonRightContent}
          {(isMobile || isTablet) && realButtonRightContent?.length > 1 && (
            <div className="page-toolbar-content-button">
              <div className="separator-toolbar-content"></div>
              <Dropdown
                overlay={
                  <Menu
                    style={{ width: 150 }}
                    items={realButtonRightContent.map((item, index) => {
                      return {
                        key: index,
                        icon: item.icon,
                        label: item.buttonTitle,
                        onClick: item.handleClick,
                        disabled: item.disabled,
                      };
                    })}
                  />
                }
                placement="bottomLeft"
                arrow
              >
                <Button
                  type="text"
                  style={{
                    marginLeft: '12px',
                    marginRight: '12px',
                    fontSize: '12px',
                  }}
                  icon={
                    <AntdIconWrapper>
                      <AiOutlineMenu />
                    </AntdIconWrapper>
                  }
                >
                  Action
                </Button>
              </Dropdown>
            </div>
          )}

          {(isMobile || isTablet) &&
            realButtonRightContent?.length <= 1 &&
            realButtonRightContent.map((buttonItem, index) => {
              buttonItem.buttonStyle = {
                marginLeft: '30px',
                marginRight: '30px',
                fontSize: '12px',
              };
              return <ButtonToolbarWrapper key={index} {...buttonItem} />;
            })}

          {!isMobile &&
            !isTablet &&
            realButtonRightContent.map((buttonItem, index) => {
              if (index === realButtonRightContent.length - 1) {
                buttonItem.buttonStyle = {
                  marginLeft: '30px',
                  marginRight: '30px',
                  fontSize: '12px',
                };
              } else {
                buttonItem.buttonTitle = undefined;
              }
              return <ButtonToolbarWrapper key={index} {...buttonItem} />;
            })}
        </div>
      </div>
      <div
        style={{
          width: '100%',
          paddingTop: '50px',
          paddingLeft: '10px',
          paddingRight: '10px',
        }}
        hidden={!showSearchInput || !isMobile}
      >
        <Input
          allowClear
          style={{ width: '100%' }}
          placeholder="Type and press enter"
          defaultValue={defaultSearchValue}
          onChange={e => {
            if (!e.target.value && handleSearch) handleSearch(e.target.value);
          }}
          onPressEnter={e => {
            if (e.target.value && handleSearch) handleSearch(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
